/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsXmarkMini: {
  name: 'xmark-mini';
  data: string;
} = {
  name: 'xmark-mini',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.354 6.354a.5.5 0 0 0-.708-.708L8 7.293 6.354 5.646a.5.5 0 1 0-.708.708L7.293 8 5.646 9.646a.5.5 0 0 0 .708.708L8 8.707l1.646 1.647a.5.5 0 0 0 .708-.708L8.707 8l1.647-1.646Z" fill="currentColor"/></svg>`,
};
